import { styled } from '@mui/material/styles'
import { blue } from '@mui/material/colors'
import { ListItemButton } from '@mui/material'

export const StyledListItemButton = styled(ListItemButton)(() => ({
  padding: '0 8px',
  backgroundColor: 'white',
  '&.Mui-selected': {
    backgroundColor: blue[800],
    color: 'white',
    '&:hover': {
      backgroundColor: blue[600]
    }
  }
}))
